import { Component } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { TitleService } from '../../services/title.service';

@Component({
    selector: 'app-chi-siamo',
    imports: [],
    templateUrl: './chi-siamo.component.html',
    styleUrl: './chi-siamo.component.css'
})
export class ChiSiamoComponent {

  constructor(private router: Router, private ts : TitleService ) {

  }
  ngOnInit(){
    this.ts.titolo = "Chi siamo";
  }
}
